module.exports = new __parcel__URL__("powerburn.cd77507b.png").toString();